"use client";

import React from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useLicenseContext } from "@/contexts/licenseContext";
import ThemeSelector from "@/components/custom-ui/theme-selector";

interface IProps {
	children: React.ReactNode;
}

/* eslint-disable @next/next/no-img-element */
export default function PageLayout({ children }: IProps ) {
	const { whitelabel, session } = useLicenseContext();
	const router = useRouter();
	const pathname = usePathname();
	const params = useSearchParams();

	const logo = React.useMemo(() => {
		return whitelabel.parameters["REGISTER_LOGO"];
	}, [whitelabel]);

	// Check if no user is logged in when changing routes
	React.useLayoutEffect(() => {
		if (session) {
			let to = `/${whitelabel.identifier}`;

			if (params.has('from')) {
				const from = params.get('from');
				to += from;
			}

			router.push(to);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pathname, params]);

	if (session) {
		return null;
	}

	return (
		<div className="layout-scroll">
			<div className="min-h-screen w-full flex flex-col justify-center items-center gap-2">

				{logo && (
					<div className="max-w-32 max-h-32">
						<img src={logo} alt="Logo" />
					</div>
				)}

				{children}

				<div className="absolute right-4 bottom-4">
					<ThemeSelector />
				</div>
			</div>
		</div>
	);
}
